import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Button } from 'react-bootstrap';
import { FaPrint, FaTimes } from 'react-icons/fa';

const DoctorPaymentReceipt = () => {
  const [clinic, setClinic] = useState(null);
  const [receiptData, setReceiptData] = useState(null);
  
  useEffect(() => {
    const data = sessionStorage.getItem('doctorPaymentReceipt');
    if (data) {
      setReceiptData(JSON.parse(data));
    }
    
    axios.get('/api/clinic.php')
      .then(res => setClinic(res.data))
      .catch(err => console.error(err));
  }, []);

  const formatCurrency = (amount) => {
    return parseFloat(amount || 0).toLocaleString('en-PK', {
      style: 'currency',
      currency: 'PKR'
    });
  };

  if (!receiptData || !clinic) {
    return <div style={{ padding: '50px', textAlign: 'center' }}><h4>Loading...</h4></div>;
  }

  const { collection, payments, billings, startDate, endDate, doctorName } = receiptData;

  return (
    <>
      <style>{`
        body { background-color: white !important; }
        @media print {
          .no-print { display: none !important; }
          body { margin: 0 !important; padding: 0 !important; background-color: white !important; }
          body * { visibility: visible !important; }
          #printable-area { position: static !important; }
          .page-header { display: table-header-group; }
          .page-footer { display: table-footer-group; }
          thead { display: table-header-group; }
          tr { page-break-inside: avoid; }
        }
        @page { size: A4; margin: 10mm; }
      `}</style>
      
      <div className="no-print" style={{ padding: '20px', backgroundColor: '#f5f5f5', textAlign: 'right' }}>
        <Button variant="success" className="me-2" onClick={() => window.print()}>
          <FaPrint className="me-2" /> Print
        </Button>
        <Button variant="secondary" onClick={() => window.close()}>
          <FaTimes className="me-2" /> Close
        </Button>
      </div>

      <div id="printable-area" style={{ maxWidth: '800px', margin: '20px auto', backgroundColor: 'white', padding: '15px', fontSize: '11px', minHeight: 'calc(100vh - 40px)', position: 'relative', paddingBottom: '40px' }}>
        
        <div style={{ textAlign: 'center', borderBottom: '2px solid #333', paddingBottom: '8px', marginBottom: '12px' }}>
          {clinic.logo && <img src={`${window.location.origin}${clinic.logo}`} alt="Logo" style={{ maxWidth: '60px', marginBottom: '5px' }} />}
          <h2 style={{ margin: '5px 0', fontSize: '18px', color: '#1565c0' }}>{clinic.name}</h2>
          <p style={{ margin: '2px 0', fontSize: '10px' }}>{clinic.address}</p>
          <p style={{ margin: '2px 0', fontSize: '10px' }}>Contact: {clinic.contactNumber}</p>
        </div>

        <h3 style={{ textAlign: 'center', marginBottom: '12px', fontSize: '15px' }}>Doctor Payment Receipt</h3>

        <div style={{ marginBottom: '12px', padding: '8px', backgroundColor: '#f5f5f5' }}>
          <p style={{ margin: '2px 0', fontSize: '10px' }}><strong>Period:</strong> {new Date(startDate).toLocaleDateString()} to {new Date(endDate).toLocaleDateString()}</p>
          <p style={{ margin: '2px 0', fontSize: '10px' }}><strong>Generated:</strong> {new Date().toLocaleDateString()} {new Date().toLocaleTimeString()}</p>
          {doctorName && <p style={{ margin: '2px 0', fontSize: '10px' }}><strong>Doctor:</strong> {doctorName}</p>}
        </div>

        <div style={{ marginBottom: '12px' }}>
          <h4 style={{ borderBottom: '1px solid #ddd', paddingBottom: '5px', marginBottom: '8px', fontSize: '13px' }}>Summary</h4>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <tbody>
              <tr style={{ borderBottom: '1px solid #ddd' }}>
                <td style={{ padding: '5px', fontWeight: 'bold', fontSize: '10px' }}>Total Collected:</td>
                <td style={{ padding: '5px', textAlign: 'right', color: '#28a745', fontWeight: 'bold', fontSize: '10px' }}>{formatCurrency(collection.totalCollected)}</td>
              </tr>
              <tr style={{ borderBottom: '1px solid #ddd' }}>
                <td style={{ padding: '5px', fontWeight: 'bold', fontSize: '10px' }}>Transferred to Owner:</td>
                <td style={{ padding: '5px', textAlign: 'right', color: '#007bff', fontWeight: 'bold', fontSize: '10px' }}>{formatCurrency(collection.totalTransferred)}</td>
              </tr>
              <tr style={{ borderBottom: '1px solid #ddd' }}>
                <td style={{ padding: '5px', fontWeight: 'bold', fontSize: '10px' }}>Pending with Doctor:</td>
                <td style={{ padding: '5px', textAlign: 'right', color: '#ffc107', fontWeight: 'bold', fontSize: '10px' }}>{formatCurrency(collection.pendingAmount)}</td>
              </tr>
            </tbody>
          </table>
        </div>



        <div>
          <h4 style={{ borderBottom: '1px solid #ddd', paddingBottom: '5px', marginBottom: '8px', fontSize: '13px' }}>Transfer Transactions</h4>
          <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #ddd' }}>
            <thead className="page-header">
              <tr style={{ backgroundColor: '#f8f9fa' }}>
                <th style={{ border: '1px solid #ddd', padding: '4px', textAlign: 'left', fontSize: '10px' }}>Date</th>
                <th style={{ border: '1px solid #ddd', padding: '4px', textAlign: 'left', fontSize: '10px' }}>Doctor</th>
                <th style={{ border: '1px solid #ddd', padding: '4px', textAlign: 'left', fontSize: '10px' }}>Period</th>
                <th style={{ border: '1px solid #ddd', padding: '4px', textAlign: 'right', fontSize: '10px' }}>Collected</th>
                <th style={{ border: '1px solid #ddd', padding: '4px', textAlign: 'right', fontSize: '10px' }}>Transferred</th>
                <th style={{ border: '1px solid #ddd', padding: '4px', textAlign: 'left', fontSize: '10px' }}>Received By</th>
              </tr>
            </thead>
            <tbody>
              {payments && payments.length > 0 ? (
                payments.map((payment, index) => (
                  <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#fff' : '#f9f9f9' }}>
                    <td style={{ border: '1px solid #ddd', padding: '3px', fontSize: '9px' }}>{new Date(payment.transferDate).toLocaleDateString()}</td>
                    <td style={{ border: '1px solid #ddd', padding: '3px', fontSize: '9px' }}>Dr. {payment.Doctor?.name}</td>
                    <td style={{ border: '1px solid #ddd', padding: '3px', fontSize: '9px' }}>
                      {new Date(payment.transferDate).toLocaleDateString()}
                    </td>
                    <td style={{ border: '1px solid #ddd', padding: '3px', textAlign: 'right', fontWeight: 'bold', fontSize: '9px' }}>{formatCurrency(payment.totalCollected || payment.amountCollected)}</td>
                    <td style={{ border: '1px solid #ddd', padding: '3px', textAlign: 'right', fontWeight: 'bold', color: '#007bff', fontSize: '9px' }}>{formatCurrency(payment.totalTransferred || payment.amountTransferred)}</td>
                    <td style={{ border: '1px solid #ddd', padding: '3px', fontSize: '9px' }}>
                      {payment.payments && payment.payments.length > 0 
                        ? payment.payments.map(p => p.receivedBy).filter(Boolean).join(', ') || '-'
                        : payment.receivedBy || '-'
                      }
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" style={{ border: '1px solid #ddd', padding: '10px', textAlign: 'center', fontSize: '10px' }}>No payment transactions found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div style={{ position: 'absolute', bottom: '15px', left: '15px', right: '15px', paddingTop: '8px', borderTop: '1px solid #ddd', textAlign: 'center', fontSize: '9px', backgroundColor: 'white', zIndex: 10 }}>
          <p style={{ margin: '2px 0' }}>This is a computer-generated receipt</p>
          <p style={{ margin: '2px 0' }}>Designed by Abdullah Arif | Contact: +92-3137323866</p>
        </div>
      </div>
    </>
  );
};

export default DoctorPaymentReceipt;
